import { render } from "./work.vue?vue&type=template&id=637c8f0c&scoped=true"
import script from "./work.vue?vue&type=script&lang=js"
export * from "./work.vue?vue&type=script&lang=js"

import "./work.vue?vue&type=style&index=0&id=637c8f0c&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637c8f0c"]])

export default __exports__